import React, { forwardRef }  from 'react'
import cx from 'classnames'
import * as styles from '../styles/components/color-fill.module.scss'

export type FillColor = 'gray' | 'black' | 'white' | 'blue' | 'brown' | 'beige'

export interface ColorFillProps extends React.HTMLProps<HTMLDivElement> {
    color: FillColor

}

const ColorFill = forwardRef<HTMLDivElement, ColorFillProps>((props, ref) => {
    const { color, children, className, ...rest } = props
    return (
        <div ref={ref} className={cx(styles.colorFill, styles[color], className)} {...rest}>
            {children}
        </div>
    )
})

export default ColorFill
